"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyFuturesOrder = exports.createFutureOrder = void 0;
const rxjs_1 = require("rxjs");
const errors_1 = require("../../../interface/errors");
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../../../interface");
const operators_1 = require("rxjs/operators");
const FutureAPI_1 = require("../../../apis/FutureAPI");
const CheckBasicRequest_1 = require("../CheckBasicRequest");
const minDumping = (symbol, price) => {
    var _a, _b, _c;
    const base = new trade_utils_lib_1.SafeDecimal(((_a = symbol.limit) === null || _a === void 0 ? void 0 : _a.dumping.min) || 0);
    const quote = new trade_utils_lib_1.SafeDecimal(((_b = symbol.limit) === null || _b === void 0 ? void 0 : _b.cost.min) || 0);
    if (!price) {
        return quote;
    }
    const quoteToBase = quote.div(new trade_utils_lib_1.SafeDecimal(price));
    return trade_utils_lib_1.SafeDecimal.max(base, quoteToBase).toDecimalPlaces((_c = symbol.amount) !== null && _c !== void 0 ? _c : 0, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
};
const maxDumping = (symbol, price) => {
    var _a, _b, _c;
    const base = new trade_utils_lib_1.SafeDecimal(((_a = symbol.limit) === null || _a === void 0 ? void 0 : _a.dumping.max) || Number.MAX_VALUE);
    const quote = new trade_utils_lib_1.SafeDecimal(((_b = symbol.limit) === null || _b === void 0 ? void 0 : _b.cost.max) || Number.MAX_VALUE);
    if (!price) {
        return quote;
    }
    const quoteToBase = quote.div(new trade_utils_lib_1.SafeDecimal(price));
    return trade_utils_lib_1.SafeDecimal.min(base, quoteToBase).toDecimalPlaces((_c = symbol.amount) !== null && _c !== void 0 ? _c : 0, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR);
};
const processFutureUIOrderRequest = (params) => {
    var _a;
    const { accountType, symbol, marginType, orderType, side, leverage, price, curPrice, markPrice, investSide, amount, realAmount, postOnly, reduceOnly, available, canBuy, riskState, leverageConfigRow, esNotional, } = params;
    // 判断参数完整
    if (!curPrice) {
        return (0, rxjs_1.throwError)(errors_1.TRADE_NO_CURRENT_PRICE);
    }
    if (orderType === interface_1.CustomOrderType.LIMIT && !price) {
        return (0, rxjs_1.throwError)(errors_1.TRADE_NO_LIMIT_PRICE);
    }
    if (!amount) {
        return (0, rxjs_1.throwError)(errors_1.TRADE_NO_INVEST);
    }
    if (!available) {
        return (0, rxjs_1.throwError)(errors_1.TRADE_NO_AVAILABLE);
    }
    if (!leverageConfigRow) {
        return (0, rxjs_1.throwError)(errors_1.TRADE_NO_LEVERAGE_ROW);
    }
    if (riskState === interface_1.TraderAccountRiskState.MERGING ||
        riskState === interface_1.TraderAccountRiskState.TAKEOVER ||
        riskState === interface_1.TraderAccountRiskState.LIQUIDATING) {
        return (0, rxjs_1.throwError)(errors_1.TRADE_DISABLE_OF_LIQUIDATION);
    }
    // 只有限价单有仅挂单
    let _orderType = orderType;
    if (orderType === interface_1.CustomOrderType.LIMIT && postOnly) {
        _orderType = interface_1.CustomOrderType.POST;
    }
    // buy  不reduce    both buy    买入
    // sell 不reduce    both sell   卖出
    // buy  reduce      short buy   平空
    // sell reduce      long sell   平多
    let positionSide = interface_1.FuturePositionSide.BOTH;
    if (reduceOnly) {
        if (side === interface_1.CustomOrderSide.BUY) {
            positionSide = interface_1.FuturePositionSide.SHORT;
        }
        else {
            positionSide = interface_1.FuturePositionSide.LONG;
        }
    }
    const amountD = new trade_utils_lib_1.SafeDecimal(amount);
    const curPriceD = new trade_utils_lib_1.SafeDecimal(curPrice);
    const limitPriceD = new trade_utils_lib_1.SafeDecimal(price);
    const tradePrice = orderType === interface_1.CustomOrderType.LIMIT ? price : curPrice;
    const tradePriceD = new trade_utils_lib_1.SafeDecimal(tradePrice);
    // 1. 判断参数符合 market info 参数合法 最小投资额
    if (tradePrice && Number(tradePrice)) {
        if (orderType === interface_1.CustomOrderType.LIMIT) {
            if (investSide === interface_1.InvestSymbolSide.base) {
                // 投 base
                const minBaseD = (0, CheckBasicRequest_1.minBase)(symbol, tradePrice);
                if (amountD.lessThan(minBaseD)) {
                    const err = errors_1.TRADE_QTY_LOW_THAN_MIN;
                    err.data.min = minBaseD.toString();
                    return (0, rxjs_1.throwError)(err);
                }
                else if (amountD.greaterThan((0, CheckBasicRequest_1.maxBase)(symbol, tradePrice))) {
                    return (0, rxjs_1.throwError)(errors_1.TRADE_QTY_HIGH_THAN_MAX);
                }
            }
            else {
                // 投quote
                const minQuoteD = (0, CheckBasicRequest_1.minQuote)(symbol, tradePrice);
                if (amountD.lessThan(minQuoteD)) {
                    const err = errors_1.TRADE_COST_LOW_THAN_MIN;
                    err.data.min = minQuoteD.toString();
                    return (0, rxjs_1.throwError)(err);
                }
                else if (amountD.greaterThan((0, CheckBasicRequest_1.maxQuote)(symbol, tradePrice))) {
                    return (0, rxjs_1.throwError)(errors_1.TRADE_COST_HIGH_THAN_MAX);
                }
            }
        }
        else {
            const minDump = minDumping(symbol, tradePrice);
            if (amountD.lessThan(minDump)) {
                const err = errors_1.TRADE_QTY_LOW_THAN_MIN;
                err.data.min = minDump.toString();
                return (0, rxjs_1.throwError)(err);
            }
            else if (amountD.greaterThan(maxDumping(symbol, tradePrice))) {
                return (0, rxjs_1.throwError)(errors_1.TRADE_QTY_HIGH_THAN_MAX);
            }
        }
    }
    // 判断限价单挂单价格合法
    if (orderType === interface_1.CustomOrderType.LIMIT && ((_a = symbol.originData) === null || _a === void 0 ? void 0 : _a.max_impact_limit)) {
        const checkPrice = markPrice !== null && markPrice !== void 0 ? markPrice : curPrice;
        const checkPriceD = new trade_utils_lib_1.SafeDecimal(checkPrice);
        if (checkPriceD.greaterThan(0)) {
            // 限价单最大冲击价格比率
            const maxImpactLimit = symbol.originData.max_impact_limit;
            if (side === interface_1.CustomOrderSide.BUY) {
                // 禁止过高买入
                const maxPrice = new trade_utils_lib_1.SafeDecimal(maxImpactLimit).add(1).mul(checkPriceD);
                if (tradePriceD.greaterThan(maxPrice)) {
                    return (0, rxjs_1.throwError)(errors_1.TRADE_LIMIT_PRICE_HIGH);
                }
            }
            else {
                // 禁止过低卖出
                const minPrice = new trade_utils_lib_1.SafeDecimal(1).minus(new trade_utils_lib_1.SafeDecimal(maxImpactLimit)).mul(checkPriceD);
                if (tradePriceD.lessThan(minPrice)) {
                    return (0, rxjs_1.throwError)(errors_1.TRADE_LIMIT_PRICE_LOW);
                }
            }
        }
    }
    // 判断仅挂单时价格合法
    if (_orderType === interface_1.CustomOrderType.POST && Number(curPrice)) {
        if (side === interface_1.CustomOrderSide.BUY) {
            // 禁止过高买入
            if (limitPriceD.greaterThan(curPriceD)) {
                return (0, rxjs_1.throwError)(errors_1.TRADE_LIMIT_POST_PRICE_HIGH);
            }
        }
        else {
            // 禁止过低卖出
            if (limitPriceD.lessThan(curPriceD)) {
                return (0, rxjs_1.throwError)(errors_1.TRADE_LIMIT_POST_PRICE_LOW);
            }
        }
    }
    // 判断canBuy是否合法
    if (canBuy) {
        if (amountD.greaterThan(new trade_utils_lib_1.SafeDecimal(canBuy))) {
            return (0, rxjs_1.throwError)(errors_1.TRADE_INVEST_MORE_THAN_CAN_BUY);
        }
    }
    // 判断交易后仓位价值是否会大于最大名义价值
    if (esNotional && new trade_utils_lib_1.SafeDecimal(esNotional).greaterThan(new trade_utils_lib_1.SafeDecimal(leverageConfigRow.notional_limit))) {
        return (0, rxjs_1.throwError)(errors_1.TRADE_NOTIONAL_NEED_LOWER_LEVERAGE_ROW);
    }
    const request = {
        accountType: accountType,
        symbol: symbol.symbol,
        type: _orderType,
        side: side,
        price: price || undefined,
        amount: realAmount,
        position_side: positionSide,
        confirmed_sensitive: true,
    };
    return (0, rxjs_1.of)(request);
};
const createFutureOrder = (preRequest) => {
    return processFutureUIOrderRequest(preRequest).pipe((0, operators_1.mergeMap)((req) => {
        return (0, FutureAPI_1.postCustomOrder)(req);
    }), (0, operators_1.catchError)((error) => {
        return (0, rxjs_1.throwError)((0, trade_utils_lib_1.getTradeDependencyInstance)().localizeError(error));
    }));
};
exports.createFutureOrder = createFutureOrder;
const verifyFuturesOrder = (preRequest) => {
    return processFutureUIOrderRequest(preRequest).pipe((0, operators_1.catchError)((error) => {
        return (0, rxjs_1.throwError)((0, trade_utils_lib_1.getTradeDependencyInstance)().localizeError(error));
    }));
};
exports.verifyFuturesOrder = verifyFuturesOrder;
